import React from 'react';
import styles from './SummaryStats.module.css';

// Import SVG icons
import Diamond from '../../assets/icons/user_actions/diamond.svg';
import CompareArrows from '../../assets/icons/user_actions/compare_arrows.svg';
import ModeComment from '../../assets/icons/communicate/mode_comment.svg';

const SummaryStats = ({ summary }) => {
  if (!summary) {
    return (
      <div className={styles.statsContainer}>
        <p className={styles.noData}>No summary data available</p>
      </div>
    );
  }

  const stats = [
    {
      label: 'Total Canvasses',
      value: summary.totalCanvasses,
      icon: Diamond,
      color: 'var(--brand-as-green-400)'
    },
    {
      label: 'Total Interviews',
      value: summary.totalInterviews,
      icon: CompareArrows,
      color: 'var(--brand-as-green-500)'
    },
    {
      label: 'Avg Interviews per Canvass',
      value: summary.totalCanvasses > 0 ? (summary.totalInterviews / summary.totalCanvasses).toFixed(1) : '0',
      icon: ModeComment,
      color: 'var(--brand-as-green-600)'
    }
  ];

  return (
    <div className={styles.statsContainer}>
      <div className={styles.statsGrid}>
        {stats.map((stat, index) => (
          <div key={index} className={styles.statCard} style={{ borderTopColor: stat.color }}>
            <div className={styles.statIcon}>
              <img src={stat.icon} alt={stat.label} className={styles.iconImage} />
            </div>
            <div className={styles.statContent}>
              <div className={styles.statValue}>{stat.value}</div>
              <div className={styles.statLabel}>{stat.label}</div>
            </div>
          </div>
        ))}
      </div>
      {summary.lastUpdated && (
        <div className={styles.lastUpdated}>
          Last updated: {new Date(summary.lastUpdated).toLocaleString()}
        </div>
      )}
    </div>
  );
};

export default SummaryStats;
